import { render, staticRenderFns } from "./AllEnrolleesOffline.vue?vue&type=template&id=c6067d12&scoped=true&"
import script from "./AllEnrolleesOffline.vue?vue&type=script&lang=js&"
export * from "./AllEnrolleesOffline.vue?vue&type=script&lang=js&"
import style0 from "./AllEnrolleesOffline.vue?vue&type=style&index=0&id=c6067d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6067d12",
  null
  
)

export default component.exports